module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "schools"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "schools-list"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.schoolsList), function(item, index) {
    return [_c('div', {
      key: index + 'coll',
      staticClass: "col-md-3"
    }, [_c('div', {
      staticClass: "schools-list-item2 wow flipInY"
    }, [_c('div', {
      staticClass: "schools-list-item2-content"
    }, [_c('div', {
      staticClass: "schools-list-item2-content-box"
    }, [_c('div', {
      staticClass: "schools-list-item2-content-tit"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "schools-list-item2-content-dec"
    }, [_c('p', {
      staticStyle: {
        "margin-bottom": "0"
      }
    }, [_vm._v("\n                        " + _vm._s(item.desc) + "\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "schools-list-item2-content-more",
      on: {
        "click": function($event) {
          return _vm.goTo(item.id)
        }
      }
    }, [_vm._v("More …")])])])])])]
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "schools-tit"
  }, [_c('div', {
    staticClass: "schools-tit-content"
  }, [_vm._v("\n        Schools\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7265985f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Schools.vue
// module id = 75
// module chunks = 0